import { Column, Entity, Index, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { NotificationGroupMemberEntity } from './notification-group-member.entity';
import { PhonePhoneTopicEntity } from './phone-phone-topic.entity';

@Index('unique_phone', ['phone'], { unique: true })
@Entity('_phone')
export class PhoneEntity extends BaseEntity {
	@Column('varchar', { name: '_phone', unique: true, length: 15 })
	public phone!: string;

	@Column('varchar', { name: '_type', nullable: true, length: 255 })
	public type!: string | null;

	@Column('tinyint', { name: '_doNotCall', width: 1, default: () => "'0'" })
	public doNotCall!: boolean;

	@Column('tinyint', { name: '_doNotText', width: 1, default: () => "'0'" })
	public doNotText!: boolean;

	@OneToMany(
		() => NotificationGroupMemberEntity,
		(notificationGroupMember) => notificationGroupMember.fkPhone,
		{},
	)
	public notificationGroupMembers!: Array<NotificationGroupMemberEntity>;

	@OneToMany(
		() => PhonePhoneTopicEntity,
		(phonePhoneTopic) => phonePhoneTopic.fkPhone,
		{},
	)
	public phonePhoneTopics!: Array<PhonePhoneTopicEntity>;
}
